/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { setSplash } from "./setSplash";
import { setIntro } from "./setIntro";
import { setAreaMap } from "./setAreaMap";
import { setModal } from "./setModal";

/**
 * Do modules.
 */
function modules() {
  setSplash();
  setIntro();
  setAreaMap();
  setModal();
}

export { modules };
